import CertificateOrderForm from "./CertificateOrderForm";

$("#certificate-order-form").each(function (){
    CertificateOrderForm.init($(this))
})